import { sync } from 'vuex-pathify';
export default {
  computed: {
    toolbarGeometries: sync('map/toolbarGeometries'),
    toolbarGeometriesLength() {
      return this.toolbarGeometries?.geojson?.features?.length || 0;
    },
    toolbarGeometriesType() {
      return this.toolbarGeometries?.type || '';
    },
  },
};
